import React, { FunctionComponent } from 'react';

import './index.scss';

const Spinner: FunctionComponent = () => <div className="common--components--spinner spinner-large" />;

export default Spinner;
